<div>
  @if (auth.isOffline()) {
<div class="fixed top-0 inset-x-0 z-50 bg-[#C8943A] text-white text-sm flex items-center justify-center gap-2 py-1.5 px-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe-off-icon lucide-globe-off"><path d="M10.114 4.462A14.5 14.5 0 0 1 12 2a10 10 0 0 1 9.313 13.643"/><path d="M15.557 15.556A14.5 14.5 0 0 1 12 22 10 10 0 0 1 4.929 4.929"/><path d="M15.892 10.234A14.5 14.5 0 0 0 12 2a10 10 0 0 0-3.643.687"/><path d="M17.656 12H22"/><path d="M19.071 19.071A10 10 0 0 1 12 22 14.5 14.5 0 0 1 8.44 8.45"/><path d="M2 12h10"/><path d="m2 2 20 20"/></svg>
  <span>Offline-Modus aktiv | Änderungen werden nicht gespeichert.</span>
</div>
  }
  <app-mksoft-loading-spinner />
  @if(auth.provisioning()) {
    <app-mksoft-onboarding />
  } @else {
    <router-outlet></router-outlet>
  }

  @defer (on idle) {
    @if (auth.loggedIn()) {
      <app-mksoft-notification-prompt />
    }
    <app-mksoft-update-notification />
  }
  <app-mksoft-toast />
  <app-mksoft-global-modal-service />
</div>
